// This icon file is generated automatically.
var PArrowdownOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.47 5.27H10.2a.25.25 0 00-.19.09L6.6 9.3V.5a.13.13 0 00-.12-.13h-.94a.13.13 0 00-.12.13v8.8L1.99 5.36a.25.25 0 00-.2-.09H.54c-.1 0-.16.13-.1.2l5.2 5.98c.2.23.55.23.75 0l5.18-5.97a.12.12 0 00-.1-.21z", "fill-rule": "nonzero" } }] }, "name": "p-arrowdown", "theme": "outlined" };
export default PArrowdownOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PArrowDownOutlined.js
// module id = 3208
// module chunks = 0